import { axios, axiosAmbient } from 'src/lib/axios';
import { FronteggContext } from '@frontegg/rest-api';
import { listSummaries } from 'src/modules/ambient_solo/store/actions/summary';

export const submitDiagnosesConfig = (encounterId, payload) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await axiosAmbient.put(
      `/encounter/${encounterId}/icd10-code`,
      { icd10_codes: payload },
      { headers }
    );
    const response = result?.data;
    return result;
  };
};

export const deleteDiagnosesConfig = (encounterId, payload) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await axiosAmbient.delete(
      `/encounter/${encounterId}/icd10-code`,
      {
        headers,
        data: { icd10_codes: payload },
      }
    );
    return result;
  };
};

export const submitDiagnosesToEHR = (encounterId, org_uuid, payload) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await axiosAmbient.post(
      `/ehr/diagnosis`,
      { icd10_codes: payload, org_uuid: org_uuid, encounter_id: encounterId },
      { headers }
    );
    const response = result?.data;
    return result;
  };
};

export const getDiagnosesBySearchString = (
  practitioner_id,
  search_string,
  page = 1
) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await axiosAmbient.get(`/icd10-codes`, {
      params: {
        practitioner_id: practitioner_id,
        search_string: search_string,
        page: page,
      },
      headers: headers,
    });
    const response = result?.data;
    return result;
  };
};
